import { render, staticRenderFns } from "./SukikamoListMenu.vue?vue&type=template&id=48d518fa&scoped=true&"
import script from "./SukikamoListMenu.vue?vue&type=script&lang=js&"
export * from "./SukikamoListMenu.vue?vue&type=script&lang=js&"
import style0 from "./SukikamoListMenu.vue?vue&type=style&index=0&id=48d518fa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d518fa",
  null
  
)

export default component.exports